export enum ProfitGoalTyp {
  PIP_BASED,
  PORTFOLIO_BASED,
}

export enum FeeTyp {
  COMMISSION_PER_LOT,
  COMMISSION_PER_100K,
}
